import { takeEvery, fork, put, all, call, delay } from "redux-saga/effects"
import {
  GET_UPSELL_START,
} from "./constant"

import { getUpSellSuccess, getUpSellFailure } from "./action"
import { getUpSellAPI } from "./api"

function* getUpSellAsync(action) {
  try {
    const response = yield call(getUpSellAPI, action.payload)
    if (response.status === 200 || 201) {
      delay(500)
  
      yield put(getUpSellSuccess(response.data))
      
    } else {
      yield put(getUpSellFailure(response.data))
    }
  } catch (error) {
    yield put(getUpSellFailure(error.response.data))
  }
}

function* getUpSell() {
  yield takeEvery(GET_UPSELL_START, getUpSellAsync)
}

function* UpSellSaga() {
  yield all([fork(getUpSell)])
}

export default UpSellSaga
